import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Cell } from 'styled-css-grid'
import cn from 'classnames'
import DragAndDrop from '@ui/DragAndDrop'
import EditableField from '@ui/EditableField'
import Container from './Container'
import Row from './Row'
import './styles.scss'

@observer
export default class MultipleRating extends Component {
  handleChangeRate = ({ id, description }) => {
    const { onChange } = this.props
    onChange({ id, text: description })
  }

  renderRate = ({ value, text, prefix, editable }) => (
    <Cell
      key={value}
      className='ui-multiple-rating__header__rate-value-container'
      middle
      center
    >
      <EditableField
        text={text}
        editable={this.props.editable && editable}
        className='ui-multiple-rating__header__rate-value'
        size='xxs'
        onBlur={description => this.handleChangeRate({ id: value, description })}
        required
        options={this.props.variablesOptions}
        prefix={prefix}
        light
      />
    </Cell>
  )

  renderRow = (row, index, columns) => {
    const {
      selected,
      editable,
      onRemove,
      inactive,
      mode,
      variablesOptions,
      textDirection,
      onSelect,
      onEdit,
      onSave
    } = this.props
    return {
      id: row.id,
      index,
      editable,
      children: (
        <Row
          key={`${row.value || row.text}-${index}`}
          index={index}
          row={row}
          columns={columns}
          selected={selected}
          editable={editable}
          onRemove={onRemove}
          inactive={inactive}
          mode={mode}
          variablesOptions={variablesOptions}
          textDirection={textDirection}
          onSelect={onSelect}
          onEdit={onEdit}
          onSave={onSave}
        />
      )
    }
  }

  render() {
    const {
      columns,
      rows,
      editable,
      mode,
      textDirection,
      onDrag,
      onDrop,
      dontKnowButton
    } = this.props

    const finalColumns = dontKnowButton ? [...columns, dontKnowButton] : columns

    return (
      <div
        className={cn('ui-multiple-rating', mode, { editable })}
        dir={textDirection}
      >
        <Container
          columns={finalColumns}
          editable={editable}
          textDirection={textDirection}
          className='ui-multiple-rating__header'
        >
          {editable && <Cell />}
          <Cell
            as='h6'
            className='margin none ui-multiple-rating__header__attributes'
            middle
          >
            Attributes
          </Cell>
          {finalColumns.map(this.renderRate)}
        </Container>
        <DragAndDrop
          itemType='row'
          onMove={onDrag}
          onDrop={onDrop}
          containerClassName='ui-multiple-rating__content'
          list={rows.map((row, index) => this.renderRow(row, index, finalColumns))}
        />
      </div>
    )
  }
}
